import { createAction } from "@reduxjs/toolkit";

const vendorAdminAddressActions = {
  setAddressValue: createAction(
    "vendor/kyb/admin/setAddressValue",
    (key: string, value: string) => ({
      payload: { key, value },
    }),
  ),
  clearAddress: createAction("vendor/kyb/admin/clearAddress"),
};

export default vendorAdminAddressActions;
